import React from 'react'
import './Footer.css';
// import fb from '..'
import { BiSolidContact } from "react-icons/bi";
import { FaLocationDot } from "react-icons/fa6";
import { ImMail } from "react-icons/im";
import { FaWhatsappSquare } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";


const Footer = () => {
  return (
    <div className='footer'>
        <div className="sb_footer section_padding">
            <div className="sb_footer-link">
                <div className="sb_footer-links_div">
                    {/* <h4>For Business</h4> */}
                    <img src="/images/logo.png" alt="" />

                    <a href="/">
                        <br></br>
                        <p>Somnath polytex is a manufacturer & exporter of sack Bags & Woven Fabric Rolls products.</p>
                    {/* <div className='icons'> */}
                    <p>
                        <FaWhatsappSquare className='icons Wp'/> 
                     <FaInstagramSquare className='icons inasta' /> 
                      <FaFacebookSquare  className='icons Fb'/>
                      </p>
                      {/* </div> */}
                    {/* <p></p>
                    <p></p> */}
                    </a>
                    {/* <a href="/healthplane">
                        <p>Health plane</p>
                    </a> */}
                    {/* <a href="/individual">
                        <p>individual</p>
                    </a> */}
                   </div>
                   <div className="sb_footer-link_div99">
                    <h4>Links</h4>
                    <a href="/">
                        <p>Home</p>
                    </a>
                    <a href="/About">
                        <p>About Us</p>
                    </a>
                    <a href="/Infrastructure">
                        <p>Infrastructure</p>
                    </a>
                    <a href="/Products">
                        <p>Products</p>
                    </a>
                    <a href="/Contact">
                        <p>Contact Us</p>
                    </a>
                   </div>
                   <div className="sb_footer-link_div99">
                   <h4> Contact Us</h4>
                    <a href="/Contact">
                    <h6><BiSolidContact /> Call Us</h6>
                        <p>+91 – 9978913401</p>

                        <p>(Enquiry For sack Bags)</p>
                        <p>+91-9978913402</p>

                        <p>(Enquiry For pp woven Fabric)</p>
                        <p>+91-9978913403</p>

                        {/* <sp>(Enquiry For Spices)</sp> */}

                    
                    <h4><ImMail /> Mail</h4>
                    <p>somnathpolytex@gmail.com</p>
                    {/* <p>info@aimniwellinternational.com</p> */}
                    </a>
                   </div>
                   <div className="sb_footer-link_div99">
                    <h4><FaLocationDot /> Location</h4>
                    <a href="/Contact">
                    <p>Office No – 8, 1rd Floor,</p>
                    <p>Sardar Plaza - 1, hadmatiya</p>
                    <p>Road, Lajai – 363641</p>
                    <p>Morbi - Rajkot highway</p>
                    </a>
                    {/* <a href="/about">
                        <p>About</p>
                    </a>
                    <a href="/press">
                        <p>Press</p>
                    </a>
                    <a href="/career">
                        <p>Career</p>
                    </a>
                    <a href="/contact">
                        <p>Contact</p>
                    </a> */}
                   </div>
                   {/* <div className="sb_footer-link_div">
                    <h4>Comming soon on</h4>
                    <div className="socialmedia">
                        <p><img src={fb} alt="" /></p>
                        <p><img src={twitter} alt="" /></p>
                        <p><img src={linkedin} alt="" /></p>
                        <p><img src={insta} alt="" /></p>
                    </div>
                   </div> */}
            </div>
            <hr></hr>
            <div className="sb_footer-below">
                <div className="sb_footer-copyright">
                    <p>
                        @{new Date().getFullYear()} CodeInn. All right reserved Somnath Polytex
                    </p>
                </div>
                <div className="sb_footer-below-links">
                    {/* <a href="/terms"> */}
                    <div><p>Design & Developed By 3R web creativity<br></br><br></br> +91-9106895436</p></div>
                    {/* </a> */}
                    {/* <a href="/privacy"><div><p>Privacy</p></div></a>
                    <a href="/security"><div><p>Security</p></div></a>
                    <a href="/cookie"><div><p>Cookie Declaration</p></div></a> */}
                    
                </div>
            </div>
        </div>
      
    </div>
  )
}

export default Footer
